import React from 'react';
import { useNavigate, Link } from "react-router-dom";
import { Navbar, Container, Nav, Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { BsHouseDoor, BsTags, BsEnvelope, BsBoxArrowRight, BsInfoCircle } from "react-icons/bs";
import "react-toastify/dist/ReactToastify.css";
import "./Header.css"; // Import for custom styling

function Header() {
    const navigate = useNavigate();
    const notifySuccess = () => toast.success("Logged out successfully!");

    const handleLogout = () => {
        localStorage.removeItem("token");
        notifySuccess();
        setTimeout(() => navigate("/login"), 1000);
    };

    return (
        <Navbar bg="dark" expand="lg" fixed="top" className="highlighted-navbar">
            <Container>
                <Navbar.Toggle aria-controls="basic-navbar-nav" className="border-0 text-light" />
                <Navbar.Collapse id="basic-navbar-nav" className="justify-content-center always-visible">
                    
                    {/* Centered Navbar Links */}
                    <Nav className="mx-auto gap-4"> 
                        <Nav.Link as={Link} to="/" className="text-light navbar-link px-3">
                            <BsHouseDoor className="nav-icon" /> <span className="nav-text">Home</span>
                        </Nav.Link>
                        <Nav.Link as={Link} to="/plan" className="text-light navbar-link px-3">
                            <BsTags className="nav-icon" /> <span className="nav-text">Pricing</span>
                        </Nav.Link>
                        <Nav.Link as={Link} to="/about" className="text-light navbar-link px-3">
                            <BsInfoCircle className="nav-icon" /> <span className="nav-text">About</span>
                        </Nav.Link>
                        <Nav.Link as={Link} to="/contact" className="text-light navbar-link px-3">
                            <BsEnvelope className="nav-icon" /> <span className="nav-text">Contact</span>
                        </Nav.Link>
                    </Nav>

                    {/* Logout Button at the End */}
                    <Nav className="ms-auto">
                        <Button
                            variant="outline-light"
                            className="me-2 btn logout-button"
                            onClick={handleLogout}
                        >
                            <BsBoxArrowRight className="nav-icon" /> <span className="nav-text">Logout</span>
                        </Button>
                    </Nav>

                </Navbar.Collapse>
            </Container>
            <ToastContainer />
        </Navbar>
    );
}

export default Header;
